import { render, staticRenderFns } from "./SimpleEditor.vue?vue&type=template&id=36e81916&scoped=true"
import script from "./SimpleEditor.vue?vue&type=script&lang=js"
export * from "./SimpleEditor.vue?vue&type=script&lang=js"
import style0 from "./SimpleEditor.vue?vue&type=style&index=0&id=36e81916&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e81916",
  null
  
)

export default component.exports